import { Injectable } from '@angular/core';
import { LanguageService, AppLanguage } from './language.service';

const TRANSLATIONS: Record<AppLanguage, Record<string, string>> = {
  en: {
    DASHBOARD: 'Dashboard',
    CUSTOMERS: 'Customers',
    EMPLOYEES: 'Employees',
    METERS: 'Meters',
    AREAS: 'Areas',
    UNIT_RATE: 'Unit rate',
    EMPLOYEE_MAP: 'Employee Map',
    BILL_REPORTS: 'Bill Reports',
    BILLING: 'Billing',
    FINANCE: 'Finance',
    EXPENSE: 'Expense',
    WAGES: 'Wages',
    WAGE_RECORDS: 'Wage Records',
    MONTHLY_PAYROLL_EXPENSE: 'Monthly Payroll Expense',
    HR: 'HR',
    PAYROLL: 'Payroll',
    PROFILES: 'Profiles',
    PAYSLIPS: 'Payslips',
    FUI_DASHBOARD: 'Expense Dashboard',
    COMPLAINT: 'Complaint (Cabashada)',

    LOAN_ENTER_ALL_FIELDS: 'Enter description, total amount, months and start month for the loan plan',

    // Payroll runs
    PAYROLL_RUNS_TITLE: 'Payroll Runs',
    MONTH: 'Month',
    NOTES: 'Notes',
    CREATE_RUN: 'Create Run',
    VIEW_DETAILS: 'View Details',

    // Profiles
    HR_PROFILES_TITLE: 'Payroll Profiles',
    PROFILE_NAME: 'Name',
    PROFILE_TYPE: 'Type',
    PROFILE_AMOUNT: 'Amount',
    PROFILE_PERCENT: '%?',
    PROFILE_ACTIVE: 'Active',
    PROFILE_ACTIONS: 'Actions',
    YES: 'Yes',
    NO: 'No',
    NO_PROFILES_YET: 'No profiles defined yet.',
    ADD_PROFILE_LINE: 'Add Profile Line',
    EDIT_PROFILE_LINE: 'Edit Profile Line',
    AMOUNT_IS_PERCENT: 'Amount is percentage of base salary',
    SAVE: 'Save',
    CANCEL: 'Cancel',

    // Loan / installment plans
    LOAN_SECTION_TITLE: 'Loan / Installment Plan',
    LOAN_DESCRIPTION: 'Description',
    LOAN_TOTAL_AMOUNT: 'Total Amount',
    LOAN_MONTHS: 'Months',
    LOAN_START_MONTH: 'Start Month (YYYY-MM)',
    LOAN_SAVE_PLAN: 'Save Loan Plan',
    LOAN_MONTHLY: 'Monthly',
    LOAN_PAID: 'Paid',
    LOAN_PAID_IN_FULL: 'Paid in full',
    LOAN_ACTIONS: 'Actions',
    LOAN_CANCEL: 'Cancel',
    LOAN_MARK_PAID: 'Mark Paid',

    // Payslips
    PAYSLIPS_TITLE: 'Payslips',
    EMPLOYEE: 'Employee',
    VIEW_PAYSLIP: 'View Payslip',
    DOWNLOAD_PDF: 'Download PDF',
    EARNINGS: 'Earnings',
    DEDUCTIONS_TITLE: 'Deductions',
    BASE_SALARY: 'Base Salary',
    ALLOWANCES_LABEL: 'Allowances',
    DEDUCTIONS_LABEL: 'Deductions',
    LOAN_LABEL: 'Loan',
    PENALTY_LABEL: 'Penalty',
    NET_PAY: 'Net Pay',

    // Monthly payroll expense
    MONTHLY_PAYROLL_EXPENSE_TITLE: 'Monthly Payroll Expense',
    VIEW_MONTHLY_TOTAL: 'View Monthly Payroll Total',
    GENERATE_EXPENSE: 'Generate Expense',
    EMPLOYEES_COUNT: 'Employees',
    TOTAL_SALARY: 'Total Salary',
    TOTAL_BONUS: 'Total Bonus',
    TOTAL_LOAN: 'Total Loan',
    TOTAL_PENALTY: 'Total Penalty',
    NET_TOTAL: 'Net Total',

    // Generic
    SELECT_MONTH_FIRST: 'Please select a month first',
    SELECT_EMPLOYEE_AND_MONTH: 'Please select employee and month',
    FAILED_LOAD_PROFILES: 'Failed to load profiles',
    SELECT_EMPLOYEE_FIRST: 'Please select an employee first',
    ENTER_NAME_AND_TYPE: 'Please enter name and type',
    PROFILE_SAVED: 'Profile saved',
    FAILED_SAVE_PROFILE: 'Failed to save profile',
    CONFIRM_DEACTIVATE_PROFILE: 'Deactivate this profile line?',
    PROFILE_DEACTIVATED: 'Profile deactivated',
    FAILED_DEACTIVATE_PROFILE: 'Failed to deactivate profile',
    FAILED_LOAD_PAYSLIP: 'Failed to load payslip',
    FAILED_LOAD_MONTHLY_REPORT: 'Failed to load monthly report',
    MONTHLY_EXPENSE_GENERATED: 'Monthly expense generated',
    FAILED_GENERATE_MONTHLY_EXPENSE: 'Failed to generate monthly expense'
  },
  so: {
    DASHBOARD: 'Golaha Kooban',
    CUSTOMERS: 'Macaamiisha',
    EMPLOYEES: 'Shaqaalaha',
    METERS: 'Mitirrada',
    AREAS: 'Xaafadaha',
    UNIT_RATE: 'Qiimaha Unugga',
    EMPLOYEE_MAP: 'Khariidadda Shaqaalaha',
    BILL_REPORTS: 'Warbixinaha Biilasha',
    BILLING: 'Biilashada',
    FINANCE: 'Maaliyad',
    EXPENSE: 'Kharash',
    WAGES: 'Mushaharro',
    WAGE_RECORDS: 'Diiwaannada Mushaharka',
    MONTHLY_PAYROLL_EXPENSE: 'Kharashka Mushaharka Bilaha',
    HR: 'HR / Shaqaalaha',
    PAYROLL: 'Mushahar',
    PROFILES: 'Xeerar Mushahar',
    PAYSLIPS: 'Slipooyinka Mushaharka',
    FUI_DASHBOARD: 'FUI Dashboard',
    COMPLAINT: 'Cabasho',

    LOAN_ENTER_ALL_FIELDS: 'Geli sharaxaad, wadarta lacagta, bilaha iyo bilowga qorshaha deynta',

    // Payroll runs
    PAYROLL_RUNS_TITLE: 'Orodka Mushaharka',
    MONTH: 'Bil',
    NOTES: 'Faallooyin',
    CREATE_RUN: 'Abuur Orod',
    VIEW_DETAILS: 'Eeg Faahfaahin',

    // Profiles
    HR_PROFILES_TITLE: 'Xeerarka Mushaharka',
    PROFILE_NAME: 'Magac',
    PROFILE_TYPE: 'Nooc',
    PROFILE_AMOUNT: 'Lacag',
    PROFILE_PERCENT: '%?',
    PROFILE_ACTIVE: 'Firfircoon',
    PROFILE_ACTIONS: 'Ficillo',
    YES: 'Haa',
    NO: 'Maya',
    NO_PROFILES_YET: 'Weli lama dhigin xeerar mushahar.',
    ADD_PROFILE_LINE: 'Ku dar xariiq mushahar',
    EDIT_PROFILE_LINE: 'Wax ka beddel xariiq mushahar',
    AMOUNT_IS_PERCENT: 'Lacagtu waa boqolley mushaharka asalka ah',
    SAVE: 'Kaydi',
    CANCEL: 'Jooji',

    // Loan / installment plans
    LOAN_SECTION_TITLE: 'Qorshaha Amaahda / Qayb-qayb bixinta',
    LOAN_DESCRIPTION: 'Sharaxaad',
    LOAN_TOTAL_AMOUNT: 'Wadarta Lacagta',
    LOAN_MONTHS: 'Bilaha',
    LOAN_START_MONTH: 'Bilow (YYYY-MM)',
    LOAN_SAVE_PLAN: 'Kaydi Qorshaha Amaahda',
    LOAN_MONTHLY: 'Bil kasta',
    LOAN_PAID: 'La bixiyay',
    LOAN_PAID_IN_FULL: 'Si buuxda ayaa loo bixiyay',
    LOAN_ACTIONS: 'Ficillo',
    LOAN_CANCEL: 'Jooji',
    LOAN_MARK_PAID: 'Calaamadee In La Bixiyay',

    // Payslips
    PAYSLIPS_TITLE: 'Slipooyinka Mushaharka',
    EMPLOYEE: 'Shaqaale',
    VIEW_PAYSLIP: 'Eeg Slipo Mushahar',
    DOWNLOAD_PDF: 'Soo dejiso PDF',
    EARNINGS: 'Dakhliga',
    DEDUCTIONS_TITLE: 'Dhimaayaal',
    BASE_SALARY: 'Mushahar Asal ah',
    ALLOWANCES_LABEL: 'Kordhinno',
    DEDUCTIONS_LABEL: 'Dhimaayaal',
    LOAN_LABEL: 'Amaah',
    PENALTY_LABEL: 'Ganaax',
    NET_PAY: 'Mushahar saafiga ah',

    // Monthly payroll expense
    MONTHLY_PAYROLL_EXPENSE_TITLE: 'Kharashka Mushaharka Bilaha',
    VIEW_MONTHLY_TOTAL: 'Eeg Wadarta Mushaharka Bishiiba',
    GENERATE_EXPENSE: 'Abuur Kharash',
    EMPLOYEES_COUNT: 'Shaqaale',
    TOTAL_SALARY: 'Wadarta Mushaharka',
    TOTAL_BONUS: 'Wadarta Gunno',
    TOTAL_LOAN: 'Wadarta Amaah',
    TOTAL_PENALTY: 'Wadarta Ganaax',
    NET_TOTAL: 'Wadarta saafiga ah',

    // Generic
    SELECT_MONTH_FIRST: 'Fadlan marka hore dooro bil',
    SELECT_EMPLOYEE_AND_MONTH: 'Fadlan dooro shaqaale iyo bil',
    FAILED_LOAD_PROFILES: 'Xeerarka mushaharka laguma soo dejin',
    SELECT_EMPLOYEE_FIRST: 'Fadlan marka hore dooro shaqaale',
    ENTER_NAME_AND_TYPE: 'Fadlan geli magac iyo nooc',
    PROFILE_SAVED: 'Xeerka mushaharka waa la keydiyay',
    FAILED_SAVE_PROFILE: 'Ku kaydinta xeerka mushaharka way fashilantay',
    CONFIRM_DEACTIVATE_PROFILE: 'Ma damin xariiqdan mushaharka?',
    PROFILE_DEACTIVATED: 'Xeerka mushaharka waa la damiyay',
    FAILED_DEACTIVATE_PROFILE: 'Damin xeerka mushaharka way fashilantay',
    FAILED_LOAD_PAYSLIP: 'Slipo mushahar laguma soo dejin',
    FAILED_LOAD_MONTHLY_REPORT: 'Warbixinta bilaha laguma soo dejin',
    MONTHLY_EXPENSE_GENERATED: 'Kharashka bilaha mushaharka waa la abuuray',
    FAILED_GENERATE_MONTHLY_EXPENSE: 'Kharashka mushaharka bilaha lama abuurin'
  }
};

@Injectable({ providedIn: 'root' })
export class TranslateService {
  constructor(private langService: LanguageService) {}

  t(key: string): string {
    const lang = this.langService.current;
    const table = TRANSLATIONS[lang] || TRANSLATIONS.en;
    return table[key] || TRANSLATIONS.en[key] || key;
  }
}
